import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import Routes from "./Routes";
// import { useSessionTimeout } from "./hooks/useSessionTimeout";
// import SessionWarning from "./components/SessionWarning";

// Component to handle session timeout - TEMPORARILY DISABLED
// const SessionManager = ({ children }) => {
//   // Auto logout after 30 minutes of inactivity
//   useSessionTimeout(30);
//   
//   return (
//     <>
//       {children}
//       <SessionWarning timeoutMinutes={30} warningMinutes={5} />
//     </>
//   );
// };

function App() {
  return (
    <AuthProvider>
      {/* <SessionManager> */}
        <Routes />
      {/* </SessionManager> */}
    </AuthProvider>
  );
}

export default App;
